export default __webpack_public_path__ + "4b5970ac7aac0fd55de38a3e7da77ea8.woff2";